import React from "react";
import Entry from "./entry";
import Controls from "./controls";

const EntryForm = ({
	dialectic,
	handleChange,
	handleKeypress,
	item,
	handleClick,
	clear,
}) => (
	<div>
		<Entry
			dialectic={dialectic}
			handleChange={handleChange}
			handleKeypress={handleKeypress}
			item={item}
		/>
		<Controls
			disabled={!dialectic[item].length}
			handleClick={handleClick}
			clear={clear}
			item={item}
		/>
	</div>
);

export default EntryForm;
